import { render, staticRenderFns } from "./approveUsers.vue?vue&type=template&id=14683d6e&"
import script from "./approveUsers.vue?vue&type=script&lang=js&"
export * from "./approveUsers.vue?vue&type=script&lang=js&"
import style0 from "./approveUsers.vue?vue&type=style&index=0&id=14683d6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports